export default __webpack_public_path__ + "static/media/icon-verified-mark.cbe47195.svg";